import { createSelector } from 'reselect';
import querySearch from 'search-query-parser';
import { join as joinPath } from 'path';

export const routing = state => state.routing;

export const location = createSelector(
  routing,
  (routing = {}) => routing.locationBeforeTransitions || {}
);

export const pathname = createSelector(
  location,
  ({ pathname } = {}) => pathname
);

export const state = createSelector(location, ({ state } = {}) => state);

export const referrer = createSelector(state, ({ referrer } = {}) => referrer);

export const referrerPathname = createSelector(
  referrer,
  referrer => (referrer && referrer.pathname ? referrer.pathname : '/')
);

export const referrerSearch = createSelector(
  referrer,
  referrer => (referrer && referrer.search ? referrer.search : '')
);

export const query = createSelector(
  location,
  (location = {}) => location.query
);

export const createQuerySelector = key =>
  createSelector(query, (query = {}) => query[key]);

export const search = createQuerySelector('q');

export const createSearchSelector = (keywords = []) =>
  createSelector(search, q => parseQ(q, keywords));

export const parseQ = (q, keywords) => {
  // Always return an object
  const parsed = querySearch.parse(q, { keywords });
  return typeof parsed === 'string' ? { text: parsed } : parsed;
};

export const status = createSearchSelector(['status']);

export const searchText = createSelector(status, parsed => parsed.text);

export const searchStatus = createSelector(status, parsed => parsed.status);

export const route = (state, { route } = {}) => route;
export const params = (state, { params } = {}) => params;
export const routes = (state, { routes } = {}) => routes;
const PARAM_PATH = /(^|\/):([^\/]+)/g; // eslint-disable-line no-useless-escape

const buildParamsReplacer = params => (m, p, k) => `${p}${params[k]}`;

export const routeParts = createSelector(
  routes,
  params,
  (routes = [], params = {}) => {
    const replaceParams = buildParamsReplacer(params);
    return routes
      .filter(r => r.path)
      .map(
        r =>
          PARAM_PATH.test(r.path)
            ? r.path.replace(PARAM_PATH, replaceParams)
            : r.path
      );
  }
);

export const parentPathname = createSelector(routeParts, (parts = []) =>
  joinPath('/', ...parts.slice(0, -1))
);

const lastPathname = pathname => {
  if (pathname.charAt(pathname.length - 1) === '/')
    pathname = pathname.slice(0, -1);
  return pathname.slice(pathname.lastIndexOf('/') + 1);
};

export const unescapeAppID = pathname => pathname.split('%2F').join('/');

export const escapeAppID = appID => appID.replace(/[/]/g, '%2F');

export const appID = createSelector(pathname, pathname => {
  const lastPath = lastPathname(pathname);
  const lastPathIndex = pathname.indexOf(lastPath);
  const correctPrecedingPath = 'action';
  const actualPreceding = pathname.slice(
    lastPathIndex - correctPrecedingPath.length - 1,
    lastPathIndex - 1
  );
  if (actualPreceding === correctPrecedingPath) return unescapeAppID(lastPath);
});

export const stepName = createSelector(params, params => params.stepName);



// WEBPACK FOOTER //
// ./js/selectors/routing.js